// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"262":"3171a0c4","658":"3171a0c4"}[chunkId] + ".chunk.css";
};